<template>
    <section class="converter">
        <div
            class="converter__content"
            :class="{ 'converter__content--blurred' : !!emittedfiles }"
        >
            <h1 class="visuallyhidden">HEIC to JPEG Converter</h1>
            <svg class="converter__logo" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 645 76"><path d="M309.6 24.325a2.356 2.356 0 0 1 3.332.013l11.69 11.781c.911.919.911 2.4 0 3.32l-11.69 11.78a2.356 2.356 0 1 1-3.345-3.319l7.705-7.765H297.62a2.356 2.356 0 1 1 0-4.712h19.672l-7.705-7.766a2.356 2.356 0 0 1 .013-3.332Z" fill="#0071EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M310.284 7.147c-16.911 0-30.631 13.72-30.631 30.632 0 16.911 13.72 30.631 30.631 30.631 16.912 0 30.632-13.72 30.632-30.631 0-16.912-13.72-30.632-30.632-30.632ZM284.366 37.78c0-14.31 11.61-25.92 25.918-25.92 14.309 0 25.919 11.61 25.919 25.92 0 14.309-11.61 25.919-25.919 25.919-14.308 0-25.918-11.61-25.918-25.92Z" fill="#0071EA"/><path d="M417.743 1.011V52.16c-.036 6.393-2.865 9.753-8.015 9.753-4.933 0-7.943-3.143-8.125-8.886h-17.88C383.65 68.957 394.821 76 408.712 76c15.741 0 26.695-9.428 26.731-23.84V1.01h-17.7ZM446.714 74.989h17.953V52.015h12.187c17.01 0 27.637-10.042 27.637-25.393 0-15.207-10.409-25.61-27.093-25.61h-30.684v73.977Zm17.953-37.061V15.424h8.85c8.052 0 12.368 4.335 12.368 11.198 0 6.827-4.316 11.306-12.368 11.306h-8.85ZM513.341 74.989h51.793V60.468h-33.84V45.26h31.192V30.703h-31.192v-15.17h33.84V1.01h-51.793V74.99ZM625.124 25.177h18.171C641.481 10.439 628.279 0 611.087 0c-19.839 0-35.508 13.907-35.508 38.108 0 23.407 14.436 37.892 35.726 37.892 19.114 0 32.788-11.812 32.788-31.679v-9.789h-32.026v13.04h14.725c-.181 7.802-5.622 12.751-15.342 12.751-11.135 0-17.554-8.2-17.554-22.431 0-14.124 6.782-22.215 17.554-22.215 7.181 0 12.078 3.504 13.674 9.5ZM.907 74.989h17.981V45.26h29.314V74.99h17.944V1.01H48.202v29.692H18.888V1.011H.908V74.99ZM77.425 74.989h51.871V60.468h-33.89V45.26h31.238V30.703H95.405v-15.17h33.891V1.01H77.425V74.99ZM158.537 1.011h-17.98V74.99h17.98V1.01ZM237.352 27.814C235.536 10.114 222.277 0 204.297 0c-19.833 0-35.271 13.546-35.271 38 0 24.346 15.074 38 35.271 38 20.414 0 31.711-13.798 33.055-26.91l-18.162-.109c-1.272 7.116-6.648 11.342-14.53 11.342-10.607 0-17.29-7.621-17.29-22.323 0-14.124 6.538-22.323 17.399-22.323 8.173 0 13.513 4.732 14.421 12.137h18.162Z" fill="#fff"/></svg>
            <p class="converter__description">Choose your files, wait a few moments and boom<br>— a ZIP folder with your converted files.</p>
            <upload-box
                :disabled="converting"
                @change="emittedfiles = $event"
            />
            <div class="converter__blurbs">
                <blurb
                    heading="Private &amp; Secure"
                    description="File conversion is completed in your browser; nothing is uploaded to the internet."
                >
                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 32"><path d="M18.818 11.733h-1.045V6.4c0-1.697-.661-3.325-1.838-4.525A6.21 6.21 0 0 0 11.5 0a6.21 6.21 0 0 0-4.435 1.875A6.466 6.466 0 0 0 5.227 6.4v5.333H4.182a4.145 4.145 0 0 0-2.956 1.251A4.316 4.316 0 0 0 0 16v11.733a4.316 4.316 0 0 0 1.226 3.016c.784.8 1.847 1.25 2.956 1.251h14.636a4.145 4.145 0 0 0 2.956-1.251A4.316 4.316 0 0 0 23 27.733V16a4.315 4.315 0 0 0-1.226-3.016 4.145 4.145 0 0 0-2.956-1.25Zm-3.136 0H7.318V6.4c0-1.132.44-2.217 1.225-3.017a4.14 4.14 0 0 1 2.957-1.25c1.11 0 2.173.45 2.957 1.25A4.311 4.311 0 0 1 15.682 6.4v5.333Z" fill="#0071EA"/></svg>
                </blurb>
                <blurb
                    heading="ZIP File"
                    description="All of your files will be conveniently placed into a ZIP file and automatically downloaded to your device."
                >
                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 24"><path d="M29 5.317a3.383 3.383 0 0 0-3.383-3.384H12.332c-.286.001-.566-.083-.805-.241L9.848.569A3.37 3.37 0 0 0 7.969 0H3.383A3.383 3.383 0 0 0 0 3.383v2.9a.483.483 0 0 0 .483.484h28.034A.483.483 0 0 0 29 6.283v-.966ZM0 19.817A3.383 3.383 0 0 0 3.383 23.2h22.234A3.383 3.383 0 0 0 29 19.817V9.183a.483.483 0 0 0-.483-.483H.483A.483.483 0 0 0 0 9.183v10.634Z" fill="#0071EA"/></svg>
                </blurb>
                <blurb
                    heading="Infinite Conversions"
                    description="Convert as many files as you want, as many times as you want."
                >
                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 14"><path d="M6.888 0C3.103 0 0 3.012 0 6.767c0 3.754 3.103 6.766 6.888 6.766 2.649 0 4.913-1.568 6.398-3.22a.967.967 0 0 0-1.438-1.293c-1.295 1.44-3.077 2.58-4.96 2.58-2.755 0-4.955-2.184-4.955-4.833 0-2.65 2.2-4.834 4.955-4.834 1.948 0 3.61 1.206 4.857 2.583a13.967 13.967 0 0 1 1.866 2.636l.008.016.005.009.008.014c0 .003.002.005.003.007V7.2h.001l.001.002.003.006.008.017a5.748 5.748 0 0 0 .142.262 15.89 15.89 0 0 0 2.033 2.829c1.38 1.523 3.525 3.217 6.29 3.217 3.784 0 6.887-3.012 6.887-6.766C29 3.012 25.897 0 22.113 0c-2.65 0-4.914 1.568-6.399 3.22a.967.967 0 1 0 1.438 1.293c1.295-1.44 3.077-2.58 4.96-2.58 2.755 0 4.955 2.184 4.955 4.834 0 2.65-2.2 4.833-4.954 4.833-1.949 0-3.61-1.206-4.858-2.582A13.974 13.974 0 0 1 15.39 6.38l-.02-.039a1.654 1.654 0 0 0-.003-.005l-.001-.003-.002-.003-.003-.005-.008-.017a5.975 5.975 0 0 0-.142-.263 15.899 15.899 0 0 0-2.033-2.829C11.797 1.695 9.652 0 6.887 0Z" fill="#0071EA"/></svg>
                </blurb>
                <blurb
                    heading="Totally Free"
                    description="Converting your files costs nothing — no catch. And the process is completely ad-free."
                >
                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 24"><path d="M26.1 20.3H2.9a.967.967 0 1 1 0-1.933h23.2a.967.967 0 1 1 0 1.933ZM24.167 23.2H4.833a.967.967 0 1 1 0-1.933h19.334a.967.967 0 1 1 0 1.933ZM.967 12.567H0v2.9A1.933 1.933 0 0 0 1.933 17.4h2.9v-.967a3.871 3.871 0 0 0-3.866-3.866Z" fill="#0071EA"/><path d="M28.033 10.633H29V6.767h-.967a5.806 5.806 0 0 1-5.8-5.8V0H6.767v.967a5.807 5.807 0 0 1-5.8 5.8H0v3.866h.967a5.807 5.807 0 0 1 5.8 5.8v.967h15.466v-.967a5.806 5.806 0 0 1 5.8-5.8ZM14.5 14.5a5.8 5.8 0 1 1 5.8-5.8 5.807 5.807 0 0 1-5.8 5.8Z" fill="#0071EA"/><path d="M14.5 12.567a3.867 3.867 0 1 0 0-7.734 3.867 3.867 0 0 0 0 7.734ZM24.167 16.433v.967h2.9A1.933 1.933 0 0 0 29 15.467v-2.9h-.967a3.87 3.87 0 0 0-3.866 3.866ZM28.033 4.833H29v-2.9A1.934 1.934 0 0 0 27.067 0h-2.9v.967a3.87 3.87 0 0 0 3.866 3.866ZM4.833.967V0h-2.9A1.933 1.933 0 0 0 0 1.933v2.9h.967A3.87 3.87 0 0 0 4.833.967Z" fill="#0071EA"/></svg>
                </blurb>
            </div>
        </div>
        <transition @afterEnter="onChange(emittedfiles)" name="fade" mode="out-in">
            <overlay v-if="!!emittedfiles">
                <transition name="fade" mode="out-in">
                    <convert-summary v-if="done" @done="reset()" @save="saveFile()" :success-count="successCount" :fail-count="failCount" />
                    <status v-else :converting="!!emittedfiles" :zipping="zipping" />
                </transition>
            </overlay>
        </transition>
    </section>
</template>

<script>
const convert = require('heic-convert');
const JSZip = require('jszip');
const FileSaver = require('file-saver');

import Overlay from '@/components/Overlay';
import UploadBox from '@/components/UploadBox';
import Blurb from '@/components/Blurb';
import Status from '@/components/Status';
import ConvertSummary from '@/components/Summary';

export default {
    name: "ConverterRoot",
    components: {
        Overlay,
        UploadBox,
        Blurb,
        Status,
        ConvertSummary
    },
    data() {
        return {
            converting: false,
            zipping: false,
            done: false,
            zip: null,
            loading: false,
            emittedfiles: null,
            files: [],
            successCount: 0,
            failCount: 0
        }
    },
    methods: {
        onChange(files) {
            this.converting = true;
            const zip = new JSZip();

            const convertFiles = new Promise((resolve) => {
                this.files = [];

                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onload = async () => {
                        const buffer = Buffer.from(reader.result);
                        try {
                            const outputBuffer = await convert({
                                buffer,
                                format: 'JPEG',
                                quality: 1,
                            });
                            this.files.push(outputBuffer);
                            
                            const filename = file.name.replace(/\.[^/.]+$/, '');
                            this.successCount++;
                            zip.file(`${filename}.jpg`, outputBuffer);
                        }
                        catch(err) {
                            this.failCount++;
                        }

                        if (i === files.length - 1) {
                            resolve();
                        }
                    };
                }
            });

            convertFiles.then(() => {
                setTimeout(() => {
                    this.loading = false;

                    if(this.successCount > 0) {
                        this.zipping = true;
                        
                        zip.generateAsync({ type: 'blob' }).then((content) => {
                            setTimeout(() => {
                                this.zip = content;
                                this.done = true;
                                this.saveFile();
                            }, 1000);
                        });
                    } else {
                        this.done = true;
                    }
                }, 1000);
            });
        },
        saveFile() {
            FileSaver.saveAs(this.zip, 'heic-to-jpg.zip');
        },
        reset() {
            this.files = [];
            this.zip = this.emittedfiles = null;
            this.done = this.converting = this.zipping = this.loading = false;
            this.successCount = this.failCount = 0;
        }
    }
}
</script>

<style>
.converter {
    position: relative;
    max-width: 900px;
    margin: 0 auto;
}

.visuallyhidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.converter__description {
    font-size: 20px!important;
    text-align: center;
    opacity: .5;
    margin-bottom: 50px;
}

.converter__logo {
    display: block;
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 25px;
}

.converter__content {
    will-change: filter;
    transition: all .5s;
}

.converter__blurbs {
    margin-top: 45px;
}

@media only screen and (min-width: 800px) {
    .converter__blurbs {
        display: flex;
        flex-wrap: wrap;
    }

    .converter__blurbs > *:nth-child(odd) {
        margin-right: 25px;
    }

    .converter__blurbs > * {
        width: calc(50% - 25px);
    }
}

.converter__content--blurred {
    filter: blur(5px);
    opacity: .3;
    pointer-events: none;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .25s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/Converter.vue